import type { ComponentPropsWithRef, FC } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { COLOR, mixins } from '#@/shared/utils/styles';

export interface InternalLinkProps extends ComponentPropsWithRef<typeof Link> {
  disabled?: boolean;
  openInNewTab?: boolean;
}

const InternalLinkBase: FC<InternalLinkProps> = ({ disabled, to, openInNewTab, ...otherProps }) =>
  disabled ? (
    <span {...otherProps} />
  ) : (
    <Link
      {...otherProps}
      to={to}
      target={openInNewTab && process.env.REACT_APP_CYPRESS !== 'true' ? '_blank' : undefined}
    />
  );

export const InternalLink = styled(InternalLinkBase)<InternalLinkProps>`
  ${mixins.link()}

  ${(props) =>
    props.disabled &&
    css`
      &,
      &:hover {
        text-decoration: none;
        color: ${COLOR.textSecondary};
        cursor: default;
      }
    `}
`;
